
import { sha512 } from 'js-sha512';

export var output = {};



export const getOddPlaces = t => {
  //console.log("get oddplaces,t:"+t+"")
  try {
    var _token = t?.toString();
    var v = '';
    //console.log("t.length:"+_token.length+"")
    for (var i = 1; i <= _token.length; i++) {     
      if(i % 2 !== 0){
        v+= _token[i-1];
      }
    }
    //console.log("token odd values:"+v+"")
    return v + '';
  } catch (e) {
    // console.log("get oddplaces,exception:"+e+"")
    return t;
  }
};

export const getEvenPlaces = t => {
  try {
    var v = '';
    let _tt = t + '';
    for (let i = 1; i < _tt.length;) {
      v += _tt[i];
      i = i + 2;
    }
    return v + '';
  } catch (e) {
    return t;
  }
};

const getHeaderObject = (reduxState, timestamp, reqBody, emptytoken) => {
  const {
    tokenReducer: { response },
    userData: { languageSelected },
  } = reduxState;

  var tokenid = response?.tokenid ?? timestamp;
  const asynctokenid = global.tokenid;
  if (asynctokenid != null && asynctokenid.length > 5) {
    tokenid = asynctokenid;
  }
  if (emptytoken === 'T') {
    tokenid = timestamp;
  }

  const platform = "WEB";
  const osVersion = "1";
  const deviceUniqueId = "";
  const appVersion = "1";
  let headerObj = {};
  let width = window.screen.width;
  let height = window.screen.height;
  const resolution = `${String(width)}x${String(height)}`;
  let _timevent = getEvenPlaces(timestamp);
  const headerHash = `${_timevent}&${tokenid}$${timestamp}$${platform}$${osVersion}`;
  const signatureKey = `${JSON.stringify(reqBody)}&SALT=${getOddPlaces(
    tokenid
  )}`;

 
  const hdSignHash = sha512(headerHash);
  const signatureHash = sha512(signatureKey);

  headerObj['User-Agent'] = output.userAgent;
  headerObj['X-IMI-App-OS'] = platform;
  headerObj['X-OS'] = platform;
  headerObj.Authorization =
    'Basic 8dbc05ac4f2912013157811dc578728bec6fc8a4c0d28f9cf0';
  headerObj['Content-Type'] = 'application/json';
  headerObj['X-IMI-App-Res'] = resolution;
  headerObj['X-IMI-App-Model'] = "WEB";
  headerObj['X-IMI-App-OSVersion'] = osVersion;
  // headerObj['X-IMI-App-UserAgent'] = `IMImobile/OoredooKuwait/${appVersion}`;
  headerObj['X-IMI-App-UserAgent'] = process.env.REACT_APP_USER_AGENT + process.env.REACT_APP_USER_AGENT_VERSION;
  headerObj['X-IMI-CHANNEL'] = process.env.REACT_APP_CHANNEL;
  //headerObj['X-IMI-CHANNEL'] = 'MOBAPP';
  headerObj['X-IMI-DEV-ID'] = deviceUniqueId;
  headerObj['X-IMI-ISREMEMBER'] = output.isLoggedInValue === 'true' ? '1' : '0';
  headerObj['X-IMI-HDSIGN'] = hdSignHash;
  headerObj['X-IMI-LANGUAGE'] = languageSelected;
  headerObj['X-IMI-NETWORK'] = output.networkType;
  headerObj['X-IMI-SERVICEKEY'] = 'A7A45FE9-ECAC-4393-BB40-357F1E5491F7';
  headerObj['X-IMI-SIGNATURE'] = signatureHash;
  headerObj['X-IMI-TOKENID'] = tokenid?.toString() ?? '';
  headerObj['X-IMI-UID'] = timestamp?.toString();
  headerObj['X-IMI-UNIQUEID'] = deviceUniqueId;
  headerObj['X-IMI-VERSION'] = appVersion;
  headerObj['X-IMI-RNST'] = new Date().getTime() + '';
  headerObj['X-IMI-APPTYPE'] = '1';
  return headerObj;
};

export { getHeaderObject };
